import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginService } from '../../login/shared/login.service';
import { environment } from './../../../environments/environment';

interface TResult {
  data: any;
  message: string;
}
@Injectable()
export class StaffService {
    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
    ) { }


    getActiveStaffs(): Observable<any> {
      const headers = new HttpHeaders({ 
        'Authorization': this.authenticate.getToken(), 
        'Content-Type': 'application/json' });

      return this.http.get(`${environment.SERVER_URL}/staff/active`, {headers});        
    }

    getStaffById(id: number): Observable<TResult> {
      const headers = new HttpHeaders({ 
        'Content-Type': 'application/json' 
      });

      return this.http.get<TResult>(`${environment.DB_API_URL}/account/by-id/${id}`, {headers})
        .pipe(
            catchError(this.handleError)
        );        
    }

    getStaffAppPermission(id: any): Observable<any> {
      const headers = new HttpHeaders({ 
        'Authorization': this.authenticate.getToken(), 
        'Content-Type': 'application/json' });

      return this.http.get(`${environment.SERVER_URL}/staff/getpermission/${id}`, {headers});        
    }

    getStaffEmploymentType(id: Number): Observable<any> {
      const headers = new HttpHeaders({ 
        'Authorization': localStorage.getItem('access_token'), 
        'Content-Type': 'application/json' });

      // return this.http.get(`${environment.GMS}/staffs/get_employment_type/${id}`, {headers}); 
      return this.http.get(`${environment.SERVER_URL}/staff/info/${id}`, {headers})
        .pipe(
          catchError(this.handleError)
        )
    }

    getEmploymentTypeList(): Observable<any> {
      const headers = new HttpHeaders({ 
        'Authorization': this.authenticate.getToken(), 
        'Content-Type': 'application/json' });

      return this.http.get(`${environment.SERVER_URL}/employment_type/list`, {headers}); 
    }

    getBranchList(): Observable<any> {
      const headers = new HttpHeaders({ 
        'Authorization': this.authenticate.getToken(), 
        'Content-Type': 'application/json' });

      return this.http.get(`${environment.DB_API_URL}/branch/list`, {headers}); 
    }

    // getSectionList(): Observable<any> {
    //   const headers = new HttpHeaders({ 
    //     'Authorization': this.authenticate.getToken(), 
    //     'Content-Type': 'application/json' });

    //   return this.http.get(`${environment.GMS}/ams/section/list`, {headers}); 
    // }

    getDepartmentList(): Observable<any> {
      const headers = new HttpHeaders({ 
        'Authorization': this.authenticate.getToken(), 
        'Content-Type': 'application/json' });

      return this.http.get(`${environment.SERVER_URL}/department/list`, {headers}); 
    }

    handleError(error: HttpErrorResponse) {
      let errorMessage = 'Unknown error!';
      let authURL = `${environment.AUTH_URL}/home?action=issue&redirectUrl=${environment.REDIRECT_URL}&appName=attendancePc`
      
      if (error.error instanceof ErrorEvent) {
        // Client-side errors
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side errors
        if (error.status == 403) {
          return of({data: null, message: '403', success: false});
        } else {
          window.location.href = authURL;
          // return of({data: null, message: '401', success: false});
        }
      }

      return of({data: null, message: errorMessage, success: false});
    }
}
